import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import ru from "./locales/ru.json";

const SUPPORTED = ["en", "ru"] as const;
type Supported = (typeof SUPPORTED)[number];

function pickInitialLocale(): Supported {
  const stored = localStorage.getItem("nyx.prefs.v1.locale");
  if (stored && (SUPPORTED as readonly string[]).includes(stored)) return stored as Supported;
  const nav = navigator.language.slice(0, 2);
  if ((SUPPORTED as readonly string[]).includes(nav)) return nav as Supported;
  return "en";
}

export const i18n = createI18n({
  legacy: false,
  locale: pickInitialLocale(),
  fallbackLocale: "en",
  messages: { en, ru },
});
